// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2FzuA","errorLogs":"styles_errorLogs__3x25J"};